(function(){"use strict";
// pv-sin-promos.js v1 — reescribe textos de domicilio/pago que vienen de otros scripts y de la config del tema
var RULES=[
  [".pv-cost__ship",/\$\s?\d/,"+ domicilio según tu zona"],
  [".pv-hero-fact",/^Domicilio\s*\$/,"Domicilio según tu zona"],
  [".pvcf__proof-item",/gratis/i,"🚚 Domicilio en Pasto · valor según tu zona"],
  [".pvcf__step h3",/1 clic/i,"Pedí por WhatsApp"],
  [".pvcf__step p",/en línea o contra entrega/i,"Te confirmamos en minutos y pagás al recibir."],
  [".pvcf__step p",/gratis desde|domicilio \$/i,"Domicilio en toda la zona urbana de Pasto. El valor depende de tu zona."],
  [".pvcf__note",/en línea/i,"Pedís por WhatsApp y pagás al recibir · Domicilios de 12pm a 10pm"],
  [".pv-ob-prog",/gratis|faltan/i,"📲 Finalizas tu pedido por WhatsApp"]
];

function apply(){
  RULES.forEach(function(r){
    document.querySelectorAll(r[0]).forEach(function(el){
      var t=(el.textContent||"").trim();
      if(t!==r[2]&&r[1].test(t))el.textContent=r[2];
    });
  });
}

var pending=0;
function schedule(){if(pending)return;pending=setTimeout(function(){pending=0;try{apply()}catch(e){}},40)}

function init(){
  apply();
  try{new MutationObserver(schedule).observe(document.body,{childList:true,subtree:true,characterData:true})}catch(e){}
}
document.readyState==="loading"?document.addEventListener("DOMContentLoaded",init):init();
})();